"use strict";

require("core-js/modules/es.symbol.js");

require("core-js/modules/es.symbol.description.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.symbol.iterator.js");

require("core-js/modules/es.array.iterator.js");

require("core-js/modules/es.string.iterator.js");

require("core-js/modules/web.dom-collections.iterator.js");

require("core-js/modules/es.array.slice.js");

require("core-js/modules/es.function.name.js");

require("core-js/modules/es.array.from.js");

require("core-js/modules/es.object.define-property.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es.array.map.js");

require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.string.split.js");

require("core-js/modules/es.string.trim.js");

var _react = require("react");

var _Window = _interopRequireDefault(require("../../../window/base/Window/Window.js"));

var _antd = require("antd");

var _projections = require("ol/proj/projections");

var _proj = require("ol/proj");

var _map = require("../../../../util/map");

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var ZoomCenterWnd = function ZoomCenterWnd(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? "Zoom Center" : _ref$title,
      _ref$visible = _ref.visible,
      visible = _ref$visible === void 0 ? true : _ref$visible,
      onClose = _ref.onClose,
      map = _ref.map,
      _ref$defaultScale = _ref.defaultScale,
      defaultScale = _ref$defaultScale === void 0 ? 500 : _ref$defaultScale,
      _ref$projs = _ref.projs,
      projs = _ref$projs === void 0 ? [map.getView().getProjection()] : _ref$projs,
      style = _ref.style;

  var _useState = (0, _react.useState)(map.getView().getProjection().getCode()),
      _useState2 = _slicedToArray(_useState, 2),
      curProjCode = _useState2[0],
      setCurProjCode = _useState2[1];

  var _useState3 = (0, _react.useState)(undefined),
      _useState4 = _slicedToArray(_useState3, 2),
      curStrCoordinate = _useState4[0],
      setCurStrCoordinate = _useState4[1];

  var _useState5 = (0, _react.useState)(defaultScale),
      _useState6 = _slicedToArray(_useState5, 2),
      curScale = _useState6[0],
      setCurScale = _useState6[1];
  /**
   * Handler called once the projection is changed in the combo box
   */


  var onProjChangeHandler = (0, _react.useCallback)(function (value) {
    //parse x and y values from input
    var oldCoordinate = (0, _map.stringToCoordinate)(curStrCoordinate, curProjCode);
    if (oldCoordinate) setCurStrCoordinate((0, _map.coordinateToString)(oldCoordinate, curProjCode, value));else setCurStrCoordinate(undefined);
    setCurProjCode(value);
  }, [curProjCode, curStrCoordinate]);

  var onCoordinateChangeHandler = function onCoordinateChangeHandler(value) {
    setCurStrCoordinate(value.target.value);
  };

  var onScaleChangeHandler = function onScaleChangeHandler(value) {
    setCurScale(value);
  };

  var onZoomHandler = (0, _react.useCallback)(function () {
    var coordinate = (0, _map.stringToCoordinate)(curStrCoordinate, curProjCode);
    var mapProjCode = map.getView().getProjection().getCode();

    if (coordinate) {
      if (curProjCode !== mapProjCode) {
        coordinate = (0, _proj.transform)(coordinate, curProjCode, mapProjCode);
      }

      (0, _map.zoomCenter)(map, curScale, coordinate[0], coordinate[1]);
    }
  }, [map, curProjCode, curStrCoordinate, curScale]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Window.default, {
    title: title,
    collapsible: true,
    onClose: onClose,
    visible: visible,
    style: style,
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_antd.Space, {
      direction: "vertical",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_antd.Select, {
        defaultValue: curProjCode,
        onChange: onProjChangeHandler,
        children: projs.map(function (proj) {
          return /*#__PURE__*/(0, _jsxRuntime.jsx)(_antd.Select.Option, {
            value: proj.getCode(),
            children: proj.getCode()
          }, proj.getCode());
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_antd.Input, {
        addonBefore: (0, _map.getCoordinateLabel)(curProjCode),
        placeholder: (0, _projections.get)(curProjCode).getAxisOrientation() !== 'neu' ? 'X, Y' : 'Y, X',
        style: {
          width: 400
        },
        value: curStrCoordinate,
        onChange: onCoordinateChangeHandler
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_antd.InputNumber //addonBefore="1/:"
      , {
        defaultValue: defaultScale,
        value: curScale,
        step: 100,
        min: 10,
        formatter: function formatter(value) {
          return "1/".concat(value);
        },
        parser: function parser(value) {
          if (value && value.split('/').length === 2) {
            return value.split('/')[1].trim();
          }

          return undefined;
        },
        placeholder: "1/Scale",
        onChange: onScaleChangeHandler,
        style: {
          width: 400
        }
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_antd.Button, {
        type: "primary",
        onClick: onZoomHandler,
        children: "Zoom"
      })]
    })
  });
};

var _default = ZoomCenterWnd;
exports.default = _default;